import React from "react";
import EntityLimitsPageBase from "../EntityLimitsPageBase";

const LAW_FIRM_USER_LIMITS_CONFIG = {
  title: "Law Firm User Limits",
  entityIdParam: "lawfirm_user_id",
  listPath: (entityId) => `/lawfirm-user/${entityId}/limits/`,
  createPath: (entityId) => `/lawfirm-user/${entityId}/limits/`,
  updatePath: (limitId) => `/limits/${limitId}/`,
  deletePath: (limitId) => `/limits/${limitId}/`,
  entityField: "lawfirm_user",
  navigateBackOnDelete: false,
  normalizeDates: false,
};

function LawFirmUserLimits() {
  return <EntityLimitsPageBase {...LAW_FIRM_USER_LIMITS_CONFIG} />;
}

export default LawFirmUserLimits;
